import axios from "axios";
import url from "../config/urlServiceConfig";

const InitiativesAPI = {
  getAll: () => axios.get("InitiativeCard"),
  getAllInitiatives: () => axios.get("Initiative"),
  getById: (id) => axios.get(`${url.initiative}/${id}`),
  getKPIsById: (id) => axios.get(`${url.initiative}/${id}/KPIs`),
  getStakeholdersById: (id) =>
    axios.get(`${url.initiative}/${id}/Stakeholders`),
  getProjectsById: (id) => axios.get(`${url.initiative}/${id}/Projects`),
  getRisksById: (id) => axios.get(`${url.initiative}/${id}/Risks`),
  createKPI: (body) => axios.post(`${url.initiative}/KPI`, body),
  createStakeholder: (body) =>
    axios.post(`${url.initiative}/Stakeholder`, body),
  createProject: (body) => axios.post(`${url.initiative}/Project`, body),
  createRisk: (body) => axios.post(`${url.initiative}/Risk`, body),
  updateKPI: (body) => axios.put(`${url.initiative}/KPI`, body),
  updateKPIValue: (body) => axios.put(`${url.initiative}/UpdateKpiValue`, body),
  updateStakeholder: (body) => axios.put(`${url.initiative}/Stakeholder`, body),
  updateProject: (body) => axios.put(`${url.initiative}/Project`, body),
  updateRisk: (body) => axios.put(`${url.initiative}/Risk`, body),
  deleteKPI: (id) => axios.delete(`${url.initiative}/KPI/${id}`),
  deleteRisk: (id) => axios.delete(`${url.initiative}/Risk/${id}`),
  deleteStakeholder: (id) =>
    axios.delete(`${url.initiative}/Stakeholder/${id}`),
  validateProject: (body) => axios.put("Validate/Project", body),
  getStatuses: () => axios.get("GetPPlusLevelStatuses"),
  getInitiativeDetails: (id) => axios.get(`${url.initiative}/InitiativeDetails/${id}`),
  create: (body) => axios.post("Initiative", body),
  update: (body) => axios.put("Initiative", body),
  delete: (id) => axios.delete(`Initiative/${id}`),
  initiativeStatuses: () => axios.get('InitiativeStatuses')
};

export default InitiativesAPI;
